import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9uq4muepj6: FaireBrandEntity = {
  token: "b_9uq4muepj6",
  type: "brand",
  name: "unit65",
  avatarUrl:
    "https://cdn.faire.com/fastly/40f223926ea90694d7604ac4b2ccefb7dfb3a765650b56397d8faa4d778ac72c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d0ae3628b0d9721d25bd3454d2946460b7a81b37c205d5fc0ed9b6889fa8db69.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/40f223926ea90694d7604ac4b2ccefb7dfb3a765650b56397d8faa4d778ac72c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d0ae3628b0d9721d25bd3454d2946460b7a81b37c205d5fc0ed9b6889fa8db69.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "UNIT65 is a small batch ceramic studio located in Los Angeles, CA where everything is made by hand. Unit65 specializes in small batch ceramics. Everything is handbuilt using various techniques. We reduce waste in the studio whenever possible, including packing orders with biodegradable packing peanuts to recycling all clay scraps and turning it into new clay so nothing goes to waste. The studio embraces the wabi sabi mentality of beauty in imperfection to ensure that every piece is truly one of a kind. Ceramics are inspired by colors and patterns found in nature, vintage patterns, and rock and roll although inspiration can be found everywhere! We also host private and intimate parties and popup classes as local shops and studios- if this is something your shop may be interested in feel free to reach out! ",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:07.165Z",
    importedBy: "entity-db-cli",
  },
};
